module.exports = __webpack_public_path__ + "a4b63d5ebfe4fd59f5a1c636f562c2f3.svg";